import { formatEndpoint } from '@frontend/duck-tape';
import type { RetrievePlanTiersArg } from './utils';

const namespace = 'clients';

const LOG_IN = 'log-in';
const RETRIEVE_CLIENT = 'retrieve';
const RETRIEVE_CLIENT_STATUS = 'status';
const REFERRER = 'referrer';
const PROMPTS = 'prompts';
const PLANS = 'plans';
const PLAN_TIERS = 'plan-tiers';

export const CLIENT_ENDPOINTS = {
  changeEmail: () => formatEndpoint('email/change', namespace),
  clerkSSOLogin: () => formatEndpoint('social-auth', namespace),
  createClient: () => formatEndpoint('', namespace),
  createMCPSocialAuth: () => formatEndpoint('mcp-social-auth', namespace),
  deleteClient: (clientId: string) => formatEndpoint(clientId, namespace),
  editProfile: () => formatEndpoint('update', namespace),
  frictionlessSSOSignup: (taskDescription?: string) =>
    formatEndpoint(
      'frictionless-sso-signup',
      namespace,
      taskDescription ? { queryParams: { task_description: taskDescription } } : undefined,
    ),
  frictionlessSignup: () => formatEndpoint('frictionless-signup', namespace),
  login: () => formatEndpoint(LOG_IN, namespace),
  retrieveClient: () => formatEndpoint(RETRIEVE_CLIENT, namespace),
  retrieveClientPrompts: () => formatEndpoint(PROMPTS, namespace),
  retrieveClientStatus: () => formatEndpoint(RETRIEVE_CLIENT_STATUS, namespace),
  retrieveMCPSocialAuth: (clerkToken: string) =>
    formatEndpoint('mcp-social-auth', namespace, { queryParams: { clerk_token: clerkToken } }),
  retrievePlanTiers: (arg?: RetrievePlanTiersArg) =>
    formatEndpoint(PLAN_TIERS, namespace, arg?.promoCode ? { queryParams: { code: arg.promoCode } } : undefined),
  retrievePlans: () => formatEndpoint(PLANS, namespace),
  retrieveReferrerDetails: (referrerId: string) =>
    formatEndpoint(REFERRER, namespace, { queryParams: { referrer_id: referrerId } }),
  updateClientPrompt: () => formatEndpoint(PROMPTS, namespace),
  updatePlan: () => formatEndpoint(`update-subscription-plan`, namespace),
};
